export const PartTypeManifestKey = 'part-type-manifest';
export const PartTypesKey = 'part-type';
export const ConfigurationHistoriesKey = 'configuration-history';
export const ChildPartTypesKey = 'child-part-type';
export const PartTypesByClientContractKey = 'part-types-by-client-contract';
export const PartTypesSoftwareFirmwareHardwareOptionsKey = 'part-types-software-firmware-hardware-options';
export const PartTypePendingTransfersKey = 'part-type-pending-transfers';